import LabelWithTooltip from 'components/Common/LabelWithTooltip'
import SfLoadingSkeleton from 'components/Common/Loadings/SfLoadingSkeleton'
import { AppConfiguration } from 'config'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { CONSENT_TOOLTIP_MESSAGES, consentBadge, REPORTING_TIMEZONE } from 'helpers/sf_constants'
import { timeFormatter } from 'helpers/sf_dashboard_helper'
import { booleanFormatter, getIANATimezoneStringForAbbreviation, insuranceCarrierListFormatter, sortInsuranceCarriers } from 'helpers/sf_utils'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Col, Row, Table, UncontrolledTooltip } from 'reactstrap'
import { getConsentInformationById } from 'store/prospects/actions'
import TcpaDisclaimerModal from './TcpaDisclaimerModal'
import DOMPurify from 'dompurify';

const Consent = (props) => {
  const {
    consent,
    consent_loading
  } = useSelector((state) => ({
    consent: state.Prospects.consent,
    consent_loading: state.Prospects.consent_loading
  }))

  const dispatch = useDispatch();
  const [widthInPixels, setWidthInPixels] = useState(0)
  const [heightInPixels, setHeightInPixels] = useState(0)
  const [viewTcpaModal, setViewTcpaModal] = useState({ action: false });

  useEffect(() => {
    if (props?.consent_certificate_id) {
      dispatch(getConsentInformationById(props?.consent_certificate_id))
    }
  }, [props?.consent_certificate_id])

  useEffect(() => {
    // Get the div element by its id or any other means
    var divElement = document.getElementsByClassName('prospects-consent-container')?.[0];
    if (divElement) {
      // Get the dimensions in pixels
      setWidthInPixels(divElement.clientWidth - 50);
      setHeightInPixels(divElement.clientHeight - 100);
    }
  }, [consent])

  return (
    <Row>
      <Col md="auto">
        <Card>
          <CardBody className="py-0">
            <Row>
              <div className="px-0">
                {consent_loading ? (
                  <SfLoadingSkeleton rows={10} cols={1} />
                ) : (
                  <div className="table-responsive px-0">
                    <Table className="mb-0 text-black">
                      <tbody>
                        <tr>
                          <td>
                            <div>
                              <div className="d-flex align-items-center mb-2">
                                <img src={consentBadge} alt='' />
                              </div>
                              <p className="mb-0">Certificate of Authenticity issued <br /> by Consent Confirmation
                                {false && <span>
                                  <i
                                    id='consent-tool-tip'
                                    className='ms-1 bx bx-info-circle text-black bx-xs'
                                  ></i>
                                  <UncontrolledTooltip placement='top' target='consent-tool-tip'>
                                    {CONSENT_TOOLTIP_MESSAGES[consent?.certificate_id]}
                                  </UncontrolledTooltip>
                                </span>}
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Certificate ID'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.CERTIFICATE_ID}
                                target='consent-certificate-id-tooltip'
                                is_active={true}
                              />
                              <div className="d-flex align-items-top mb-0">{consent?.certificate_id}</div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Date'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.DATE}
                                target='consent-date-tooltip'
                                is_active={true}
                              />
                              <p className="mb-0">{consent?.date && format(utcToZonedTime(new Date(consent?.date), getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa')}</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Form Completed'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.FORM_COMPLETED}
                                target='consent-form-completed-tooltip'
                                is_active={true}
                              />
                              {booleanFormatter(consent?.is_completed, true)}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name="Consent Captured"
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.CONSENT_CAPTURED}
                                target="consent-captured-tooltip"
                                is_active={true}
                              />
                              {consent?.insurance_carriers?.length > 0 ?
                                insuranceCarrierListFormatter(sortInsuranceCarriers(consent?.insurance_carriers || [])) :
                                <div>No Consent Captured</div>
                              }
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name="TCPA Disclaimer"
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.TCPA_DISCLAIMER}
                                target="tcpa-disclaimer-tooltip"
                                is_active={true}
                              />
                              {consent?.tcpa_disclaimer_text ? (
                                <>
                                  <a
                                    href="#"
                                    target="_blank"
                                    className="mb-0"
                                    style={{ color: '#2f9ee9', textDecoration: 'none' }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setViewTcpaModal({ action: true });
                                    }}
                                  >
                                    View Disclaimer
                                  </a>
                                  <TcpaDisclaimerModal
                                    state={viewTcpaModal}
                                    disclaimerText={
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: DOMPurify.sanitize(consent.tcpa_disclaimer_text),
                                        }}
                                      />
                                    }
                                    onCloseStateEvent={() => setViewTcpaModal({ action: false })}
                                  />
                                </>
                              ) : (
                                <div>No TCPA Disclaimer found</div>
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Duration'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.DURATION}
                                target='consent-duration-tooltip'
                                is_active={true}
                              />
                              <p className='mb-0'>{timeFormatter(consent?.duration)}</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <LabelWithTooltip
                                name='Page URL'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.PAGE_URL}
                                target='consent-page-url-tooltip'
                                is_active={true}
                              />
                              <p className='text-truncate mb-0' style={{
                                width: "221px",
                                overflow: "hidden"
                              }}><a href={consent?.source_page_url} target='_blank' className='mb-0 text-sfblue '>{consent?.source_page_url}</a></p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='IP Address'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.IP_ADDRESS}
                                target='consent-ip-address-tooltip'
                                is_active={true}
                              />
                              <p className='mb-0'>{consent?.ip}</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Location'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.LOCATION}
                                target='consent-location-tooltip'
                                is_active={true}
                              />
                              <p className='mb-0'>{consent?.location}</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ cursor: 'default' }}>
                            <div>
                              <LabelWithTooltip
                                name='Browser & OS'
                                tooltip_message={CONSENT_TOOLTIP_MESSAGES.BROWSER}
                                target='consent-browser-os-tooltip'
                                is_active={true}
                              />
                              <p className='mb-0'>{consent?.os_browser_details}</p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col>
        <Row>
          <Col>
            <Card>
              <CardBody className='py-0'>
                <div className='prospects-consent-container'>
                  {(consent && widthInPixels && heightInPixels) && <iframe
                    title='Consent'
                    className='prospects-consent'
                    src={`${AppConfiguration.CONSENT_REPLAYER_URL}/replay_session/${props?.consent_certificate_id}?width=${widthInPixels}&height=${heightInPixels}&api_token=${AppConfiguration.CONSENT_API_TOKEN}`}
                  ></iframe>}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Consent